var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('custom-table',{ref:"customTable",attrs:{"columns":_vm.columns,"custom-view":_vm.customView,"footer-actions":_vm.footerActions,"sums":_vm.sums,"table-height":"calc(100vh - 205px)","api-url":"/payable-list"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }